import { FaRegHandshake } from "react-icons/fa"
import { BiLineChartDown, BiLineChart, BiExit } from "react-icons/bi"
import { AiOutlineAlert } from "react-icons/ai"
import { BiTimer } from "react-icons/bi"

export const menu = [
  {
    title: "Accounts",
    path: "/",
    icon: FaRegHandshake,
  },
  {
    title: "Open Positions",
    path: "/positions",
    icon: FaRegHandshake,
  },
  {
    title: "Transaction",
    path: "/create-transaction",
    icon: AiOutlineAlert,
  },
  {
    title: "Create User",
    path: "/create-user",
    icon: AiOutlineAlert,
  },

  {
    title: "Change Password",
    path: "/change-password",
    icon: AiOutlineAlert,
  },
  {
    title: "Summaries",
    path: "/summaries",
    icon: AiOutlineAlert,
  },

  {
    title: "Orders",
    path: "/orders",
    icon: AiOutlineAlert,
  },

  {
    title: "Connections",
    path: "/connections",
    icon: AiOutlineAlert,
  },

  {
    title: "Report",
    path: "/commission-report",
    icon: AiOutlineAlert,
  },
  {
    title: "Trades by IP",
    path: "/trades-by-ip",
    icon: AiOutlineAlert,
  },

  {
    title: "Change User Group",
    path: "/change-user-group",
    icon: AiOutlineAlert,
  },
  {
    title: "D & W Report",
    path: "/deposits-and-withdrawals",
    icon: AiOutlineAlert,
  },
  {
    title: "Credit Facility",
    path: "/credit-facility",
    icon: AiOutlineAlert,
  },
  {
    title: "Daily Report",
    path: "/daily-report",
    icon: AiOutlineAlert,
  },
  {
    title: "Order History",
    path: "/orders-history",
    icon: AiOutlineAlert,
  },
  {
    title: "Deal History",
    path: "/deals-history",
    icon: AiOutlineAlert,
  },
  {
    title: "Logout",
    path: "/logout",
    icon: BiExit,
  },
];

